import {z} from "zod";

export const MAX_DELAY_MINUTES = 15;

export const delaySchema = z.object({
  reason: z.string({message: "This field is requried"}).min(1, {message: "This field is requried"}),
  delay_minutes: z.coerce
    .number({message: "This field is requried"})
    .min(1, {message: "This field is required"})
    .max(MAX_DELAY_MINUTES, {message: `Delay must be less than ${MAX_DELAY_MINUTES} minutes`}),
});

export const interruptSchema = z.object({
  reason: z.string({message: "This field is requried"}).min(1, {message: "This field is requried"}),
});
